module.exports = __webpack_public_path__ + "img/pro_four_2.91703fd6.jpg";